export default __webpack_public_path__ + "static/3-352351c939ab954c08f6bae2f63c873c.jpg";